import axios from "axios";
import { key } from "../../util/config";
import { Toast } from "../../util/toast";

import { SET_USER } from "./types";

export const loginRegister = (data) => (dispatch) => {
    const url = data.type === "login" ? "user/login" : "user/register"
    axios
        .post(`${url}?key=${key}`, data.data)
        .then((res) => {
            if (res.data.status) {
                // Toast("success", data.type === "login" ? "You have successfully logged in." : "You have successfully registered.");
                dispatch({ type: SET_USER, payload: res.data.token });
                window.location.href = "/";
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};

// store contact us detail
export const contactUs = (data) => (dispatch) => {

    axios
        .post(`contactus?key=${key}`, data)
        .then((res) => {
            if (res.data.status) {
                Toast("success", "Your message sent succesfully.");
                setTimeout(() => {
                    window.location.href = "/#hero";
                }, 300)
            } else {
                Toast("error", res.data.message);
            }
        })
        .catch((error) => Toast("error", error.message));
};